import { guaziNavItems } from '@/components/feature/guaziNav';
import { useGuaziSectionHref } from '@/hooks/guaziUseSectionNav';
import { useGuaziSiteConfig } from '@/hooks/guaziUseSiteConfig';

export default function GuaziFooter() {
  const sectionHref = useGuaziSectionHref();
  const { config } = useGuaziSiteConfig();

  return (
    <footer id="contact" className="guazi-anchor bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {/* 品牌 */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg overflow-hidden shrink-0">
                <img
                  src="/images/guazi-app-icon.png"
                  alt="瓜子影视软件图标"
                  title="瓜子影视APP下载官网"
                  className="w-full h-full object-cover"
                />
              </span>
              <span className="font-heading font-extrabold text-xl text-background-50">瓜子影视</span>
            </div>
            <p className="text-sm leading-6 text-background-200/90">
              瓜子影视，一款清爽流畅的影视播放软件。海量高清片库，多端同步，随时随地畅享好剧。
            </p>
            <p className="mt-3 text-sm text-primary-300">官方域名：{config.domain}</p>
          </div>

          {/* 模块导航 */}
          <div>
            <h4 className="font-heading font-bold text-background-50 text-base mb-4">
              <a href={sectionHref('home')} className="cursor-pointer">页面导航</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {guaziNavItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={sectionHref(item.id)}
                    className="text-sm text-background-200/90 hover:text-primary-300 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系我们 */}
          <div>
            <h4 className="font-heading font-bold text-background-50 text-base mb-4">
              <a href="#contact" className="cursor-pointer">联系我们</a>
            </h4>
            <p className="text-sm text-background-200/90 mb-3">商务合作、问题反馈，欢迎通过邮箱联系：</p>
            <div className="flex items-center gap-2 px-3 py-3 bg-secondary-800 rounded-lg border border-secondary-700">
              <span className="w-8 h-8 flex items-center justify-center text-primary-300 shrink-0">
                <i className="ri-mail-line text-lg" />
              </span>
              <span className="text-sm text-background-50 select-all break-all">{config.contactEmail}</span>
            </div>
            <p className="mt-3 text-xs text-background-300/70">工作时间：周一至周五 9:00 - 18:00</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-background-300/80">
            瓜子影视官方
          </p>
          <p className="text-xs md:text-sm text-background-300/80">
            © 2026 {config.siteName} 保留所有权利
          </p>
        </div>
      </div>
    </footer>
  );
}